import React from "react";
import { Nav, SpineRail, Footer } from "../components/site/Chrome";
import Hero from "../components/site/Hero";
import { TrustStrip, Marquee, Specializations } from "../components/site/Specializations";
import { Symptoms, About } from "../components/site/Education";
import { Community, CaseNotes } from "../components/site/CommunityCases";
import { BlogPreview, FollowAlong, Gallery, VideoLibrary } from "../components/site/Media";
import Contact from "../components/site/Contact";

export default function Home() {
  return (
    <div className="bg-[#F3F5F4] min-h-screen" data-testid="home-page">
      <SpineRail />
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <Specializations />
        <Symptoms />
        <About />
        <Community />
        <CaseNotes />
        <Marquee />
        <BlogPreview />
        <FollowAlong />
        <Gallery />
        <VideoLibrary />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
